<script lang="ts">
import { getPriceParamsFromQuery } from '~/utility/getPriceParamsFromQuery'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import GenericLink from '../link-generic/GenericLink'
import { GenericLinkData } from '../link-generic/GenericLinkData'
import { PuLinkProps } from './PuLinkProps'
import { logger } from '~/utility/logger'

@Component({
  mixins: [GenericLink],
  emits: ['url-generated'],
})
class PuLink extends Vue implements PuLinkProps {
  @Prop()
  query?: Record<string, any>

  @Prop()
  excludeType?: string

  @Prop()
  name?: string

  @Prop()
  path?: string

  @Prop()
  forceQueryParams?: string[]

  @Prop()
  params?: Record<string, any>

  @Prop()
  nonSeo?: boolean

  @Prop()
  removeFacetQuery?: boolean

  @Prop({ default: false })
  debugBreadcrumbs?: boolean

  get linkData(): GenericLinkData {
    const data = this.moveSingleFacetToPath()
    const urlData = {
      name: this.name,
      ...data,
      params: {
        ...(this.params || {}),
      },
      forceQueryParams: this.forceQueryParams,
    }
    return urlData
  }

  moveSingleFacetToPath() {
    const query: Record<string, string | string[] | undefined> = {
      ...getPriceParamsFromQuery(this.$route.query),
      ...(this.query || {}),
    }

    if (this.debugBreadcrumbs) {
      logger('🔍 PULINK_LOG - PuLink processing facets:', {
        thisQuery: this.query,
        routeQuery: this.$route.query,
        combinedQuery: query,
        removeFacetQuery: this.removeFacetQuery,
        nonSeo: this.nonSeo,
        path: this.path,
      })
    }

    if (this.removeFacetQuery) {
      delete query.facet
      return {
        path: this.path,
        query,
      }
    }

    let facet: string | undefined
    if (Array.isArray(this.query?.facet)) {
      // Multiple facets MUST use query params, not path format
      if (this.query.facet.length > 1) {
        return {
          path: this.path,
          query: this.query,
        }
      }
      // Single facet in array
      facet = this.query.facet.length === 1 ? this.query.facet[0] : ''
    } else {
      // Single facet as string
      facet = this.query?.facet
    }

    if (this.nonSeo || this.name || !facet) {
      return {
        path: this.path,
        query: this.query,
      }
    }

    const facetPath = `-/${facet}/`
    delete query.facet
    if (this.path?.includes(facetPath)) {
      if (this.debugBreadcrumbs) {
        logger('🔍 PULINK_LOG - PuLink facet already in path:', this.path)
      }
      return {
        path: this.path,
        query,
      }
    }
    const finalPath = (this.path ? this.path : '/') + facetPath
    if (this.debugBreadcrumbs) {
      logger('🔍 PULINK_LOG - PuLink adding facet to path:', {
        originalPath: this.path,
        facetPath,
        finalPath,
      })
    }
    return {
      path: finalPath,
      query,
    }
  }
}

export default toNative(PuLink)
</script>
